<template>
  <Layout footer>
    <NSpin :show="initLoading" :class="{ 'py-40': initLoading }">
      <div class="app-container" v-if="!initLoading">
        <div class="flex items-center py-5 text-base border-b border-gray-300" style="background-color: #faf9f9">
          <span class="mr-1">当前位置：</span>
          <NBreadcrumb>
            <NBreadcrumbItem @click="gotoHome">首页</NBreadcrumbItem>
            <NBreadcrumbItem>学习中心</NBreadcrumbItem>
            <NBreadcrumbItem>代领协议</NBreadcrumbItem>
          </NBreadcrumb>
        </div>
        <div class="mt-7 p-10 border border-gray-300">
          <div class="flex items-start pb-28 border-b-2 border-dashed border-gray-300">
            <img style="width: 225px" class="flex-shrink-0" :src="imgBaseUrl + userInfo.photo" alt="头像信息" />
            <div class="ml-20">
              <p class="text-xl">{{ userInfo.stuName }}</p>
              <p class="mt-4 text-gray-500 text-base"> 机构：{{ userInfo.tenantName }} </p>
              <p class="mt-2 text-gray-500 text-base">班级：{{ userInfo.className }}</p>
              <p class="mt-2 text-gray-500 text-base">班主任：{{ userInfo.headTeacherName }}</p>
              <p class="mt-4 text-base" style="color: #DF1A23">
                签署日期：{{ userInfo.agencyAgreementDate || '-' }}
              </p>
            </div>
            <div class="flex flex-col ml-auto">
              <n-button type="primary" class="ml-auto">
                {{ flag ? '未签署' : '已签署' }}
              </n-button>
              <n-button @click="handleLook" type="primary" class="ml-auto mt-3" :loading="lookLoading">
                查&nbsp;&nbsp;&nbsp;看
              </n-button>
            </div>
          </div>
          <div class="inline-block mt-4 py-1 text-xl border-b-2 border-dashed border-gray-300">
            代领协议
          </div>
          <div class="flex items-center justify-center mb-8 mt-14">
            <div class="qrcode text-center">
              <img src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/zhihuirencai/type___jumpAgreement.png" alt="二维码" />
              <p>代领协议二维码</p>
            </div>
            <p class="ml-8">
              请用<span style="color: #ea4c00">智慧人才APP</span>
              扫描代领协议二维码进行签署
            </p>
          </div>
        </div>
      </div>
    </NSpin>
  </Layout>

  <n-modal v-model:show="showContent" :mask-closable="false" :bordered="false" preset="card" title="查看协议"
    style="width: 800px">
    <div v-html="content"></div>
  </n-modal>
</template>

<script setup>
import { useRouter } from 'vue-router';
import Layout from '@/components/Layout';
import { reactive, ref } from 'vue';
import { getUserInfoApi, verifyAgencyAgreementApi, getAgencyAgreementApi } from '@/api';

const router = useRouter();
function gotoHome () {
  router.push('/');
}

const flag = ref(true);
verifyAgencyAgreementApi().then(res => {
  flag.value = res.data;
});

const imgBaseUrl = 'https://qingjuck.oss-cn-shanghai.aliyuncs.com/';
const userInfo = reactive({});
const initLoading = ref(true);
getUserInfoApi()
  .then(res => res.data)
  .then(res => {
    const { photo, stuName, tenantName, className, headTeacherName, agencyAgreementDate } = res;
    Object.assign(userInfo, {
      photo,
      stuName,
      tenantName,
      className,
      headTeacherName,
      agencyAgreementDate,
    });
  })
  .finally(() => (initLoading.value = false));

const content = ref(null);
const showContent = ref(false);
const lookLoading = ref(false);
async function handleLook () {
  if (!content.value) {
    lookLoading.value = true;
    await getAgencyAgreementApi().then(res => {
      res = res.data.content;
      content.value = res;
    });
    lookLoading.value = false;
  }
  showContent.value = true;
}
</script>

<style lang="scss" scoped>
:deep(.n-breadcrumb-item) {
  font-size: 16px;
}
.qrcode > img {
  width: 170px;
  height: 176px;
  margin-bottom: 5px;
}
</style>
